import Vue from "vue";
export const formatNumberMoney = (number) => {
  return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
}
export const debounce = function (fn, delay) {
  let timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    let args = arguments
    let that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}
export const clone = (object) => JSON.parse(JSON.stringify(object));
export const map = (array) => {
  const map = {};
  array.forEach((item) => {
    map[item.id] = item;
  });
  return map;
};
export const array = (map) => {
  const array = [];
  for (const key in map) {
    array.push(map[key]);
  }
  return array;
};
export const reflect = (fromObject, toObject) => {
  for (const key in fromObject) {
    toObject[key] = fromObject[key];
  }
};
export const filterMap = (map, property, value) => {
  const filtered = [];
  for (const key in map) {
    if (
      map[key][property] &&
      map[key][property] == value &&
      (!map[key].deletedAt || map[key].deletedAt === null)
    ) {
      filtered.push(map[key]);
    }
  }
  return filtered;
};
export const autoLoad = async (mapName, module) => {
  // module is auto load
  // map is not marked as empty
  // when module is not loading
  if (
    module.autoLoad &&
    !module.autoLoad.emptyMap[mapName] &&
    module.autoLoad.loading === false &&
    (!module.autoLoad.counter || module.autoLoad.counter < 5)
  ) {
    module.autoLoad.loading = true;
    const mapNames = [];
    Object.keys(module).forEach((key) => {
      if (
        module[key] !== null &&
        typeof module[key] == "object" &&
        !Array.isArray(module[key]) &&
        Object.keys(module[key]).length == 0
      ) {
        mapNames.push(key);
      }
    });
    const response = await module.autoLoad.loader.call();
    if (response) {
      mapNames.forEach((name) => {
        if (response[name]) {
          response[name].forEach((item) => {
            if (name == "staffs") {
              Vue.set(module[name], item.id, item);
            } else {
              module[name][item.id] = item;
            }
          });
          if (Object.keys(module[name]).length == 0) {
            module.autoLoad.emptyMap[name] = true;
          }
        } else {
          console.warn(
            "MODULE AUTOLOADED BUT API RESPONSE NO DATA FOR THIS MAP <" +
              name +
              ">",
            module
          );
        }
      });
    }
    if (!module.autoLoad.counter) module.autoLoad.counter = 1;
    else module.autoLoad.counter++;
    module.autoLoad.loading = false;
  }
};
export const classMap = {};

export const serialize = (obj) => {
  if (!obj) return "";
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      if (Array.isArray(obj[p])) {
        obj[p].forEach((e) => {
          str.push(encodeURIComponent(p) + "[]=" + encodeURIComponent(e));
        });
      } else {
        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
      }
    }
  return str.join("&");
};

//for array
export const replaceByKey = function(arr, obj, key) {
  let index = arr.findIndex((val) => val[key] === obj[key]);
  if (index === -1) {
    arr.push(obj);
  } else {
    arr[index] = Object.assign(arr[index], obj);
  }
  return arr;
};

//for array
export const mergeByKey = (target, source, prop) => {
  source.forEach((sourceElement) => {
    let targetElement = target.find((targetElement) => {
      return sourceElement[prop] === targetElement[prop];
    });
    targetElement
      ? Object.assign(targetElement, sourceElement)
      : target.push(sourceElement);
  });
  return target;
};

export const toFixedNumber = (num, digits, base) => {
  var pow = Math.pow(base||10, digits);
  return Math.round(num*pow) / pow;
}

export const sleep = (ms) => {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export const scrollTopWindow = () => {
  window.scrollTo(0,0);
}

export default {};
